import { c as components } from "../../../chunks/component-client-CuoNe3Al.mjs";
const sheet = components.sheetV1;
const current = sheet.current;
const open = sheet.open;
const close = sheet.close;
const back = sheet.back;
const create = sheet.create;
const events = sheet.events;
const getOpenSheet = sheet.getOpenSheet;
const getHeader = sheet.getHeader;
const getContent = sheet.getContent;
const getActions = sheet.getActions;
export {
  back,
  close,
  create,
  current,
  events,
  getActions,
  getContent,
  getHeader,
  getOpenSheet,
  open,
  sheet
};
/*                                     */
